export default __webpack_public_path__ + "static/media/suggested_article.88d68ca4.svg";